export default __webpack_public_path__ + "static/media/bouncingball.5bdd0eaa.png";